import React, { useEffect, useState } from 'react';
import { fetchAllConversations } from '../../api/ConversationApi';
import type { Conversations } from '../model';
import { LoadingSpinner } from '../ui';
import ItemList from '../list/ItemList';
import './Conversations.scss';

const ConversationsComponent: React.FC = () => {
  const [conversations, setConversations] = useState<Conversations[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadConversations = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await fetchAllConversations();
        setConversations(data);
      } catch (err) {
        setError('Не удалось загрузить разговоры');
        console.error('Error loading conversations:', err);
      } finally {
        setLoading(false);
      }
    };

    loadConversations();
  }, []);

  if (loading) {
    return (
      <div className="conversations-loading">
        <LoadingSpinner text="Загрузка разговоров..." />
      </div>
    );
  }

  if (error) {
    return (
      <div className="conversations-error">
        <div className="error-message">
          <h3>Ошибка загрузки</h3>
          <p>{error}</p>
          <button
            className="retry-button"
            onClick={() => window.location.reload()}>
            Попробовать снова
          </button>
        </div>
      </div>
    );
  }

  if (conversations.length === 0) {
    return (
      <div className="conversations-empty">
        <div className="empty-state">
          <h3>Нет разговоров</h3>
          <p>У вас пока нет активных разговоров</p>
        </div>
      </div>
    );
  }

  return (
    <div className="conversations-container">
      <ItemList
        items={conversations}
        linkPrefix="conversation"
        renderName={conversation => conversation.topic || 'Без названия'}
        renderStatus={conversation => conversation.type}
      />
    </div>
  );
};

export default ConversationsComponent;
